import { render, staticRenderFns } from "./ModalConfirmPrescriptionForm.vue?vue&type=template&id=61496c50&scoped=true"
import script from "./ModalConfirmPrescriptionForm.vue?vue&type=script&lang=js"
export * from "./ModalConfirmPrescriptionForm.vue?vue&type=script&lang=js"
import style0 from "./ModalConfirmPrescriptionForm.vue?vue&type=style&index=0&id=61496c50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61496c50",
  null
  
)

export default component.exports